module.exports = {"id":"225114","name":"Mimoun Mahi","rating":"73","photo":"./data/images/photos/0/225114.png","club":{"name":"FC Groningue","logo":"./data/images/clubs/FCGroningue.png"},"positions":["BU","MG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MimounMahi0.json
// module id = 3047
// module chunks = 0